import { useEffect } from "react"
import { setDocumentTitle } from "shared/util"

import { useTenant } from "features/tenant/context"
import { useSideMenu } from "components/sideMenu/container"
import { useTopBar } from "components/topBar/container"

type GuideLineListPageProps = {
  topBarState: ReturnType<typeof useTopBar>
  sideMenuState: ReturnType<typeof useSideMenu>
}
export const GuideLineListPage = ({
	topBarState: { setBreadCrumbs },
	sideMenuState: { setActivePage },
}: GuideLineListPageProps) => {
  const tenant = useTenant()
	useEffect(
    () => {
      setBreadCrumbs([{ label: 'ガイドライン' }])
      setDocumentTitle('ガイドライン一覧', tenant.tenantName)
			setActivePage('convention')
    },
    [tenant, setBreadCrumbs, setActivePage]
  )
	return <></>
}